<template>
  <div class="container">
    <div class="card maadi-dark-card mt-2">
      <div class="card-header">
        Wordpress Linker
      </div>
      <div class="card-body p-2 d-flex">
        <div class="p-2 w-50" v-if="allTags !== null" style="max-height:30vw; overflow-y:auto">
          <div class="d-flex maadi-row  m-1" v-for="tags in allTags" :key="tags.id">
            <div @click="setTag(tags)" class="flex-fill p-3" style="cursor: pointer; ">
              {{tags.name}}
            </div>
          </div>
        </div>
        <div class="p-2 w-50">
          <single-wordpress-tag v-bind:tag-object="selectedTag"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WordpressAPI from '../../../api/wordpressTags'
import AccountSelector from '../../tools/AccountSelector'
import SingleWordpressTag from './SingleWordpressTag'

export default {
  components: {AccountSelector, SingleWordpressTag},
  name: 'wordpress-tags-list',
  data: function () {
    return {
      allTags: null,
      selectedTag: null
    }
  },
  beforeMount () {
    this.mountTags()
  },
  methods: {
    mountTags () {
      WordpressAPI.getTags().then(response => {
        this.allTags = response.data
      }).catch(error => { console.log(error) })
    },
    setTag (tag) {
      tag.account_id = null
      this.selectedTag = tag
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/marcomm/wordpressLinker/WordpressLinker.vue